export default class Medicoes {
  constructor() {
    this.id = "";
    this.descricao = "Novas Medições";
    this.local = "";
    this.posicao = "";
    this.ano = "";
    this.comprimento = "";
    this.perimetro = "";
    this.diametro = "";
    this.pmta = "";
    this.calotaa = "";
    this.calotab = "";
    this.itens = this.getDefaultItens();
  }

  update(med) {
    this.descricao = med.descricao;
    this.local = med.local;
    this.posicao = med.posicao;
    this.ano = med.ano;
    this.comprimento = med.comprimento;
    this.perimetro = med.perimetro;
    this.diametro = med.diametro;
    this.pmta = med.pmta;
    this.calotaa = med.calotaa;
    this.calotab = med.calotab;
    this.itens = med.itens;
  }

  getDefaultItens() {
    let list = [];
    for (let index = 0; index < 26; index++) {
      list.push({
        a: "0.0",
        b: "0.0",
        c: "0.0",
        d: "0.0",
      });
    }
    return list;
  }
}
